var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HomeHeader'),_c('TypeNav'),_c('ListContainer'),_c('MoreList'),_c('BiddingList'),_c('HomeFloor')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }